export const getLanguageOptions = ({ t }) => [
  { value: 'all', label: t.global.all },
  { value: 'english', label: t.global.languages.english },
  { value: 'french', label: t.global.languages.french },
  { value: 'bilingual', label: t.global.languages.bilingual }
]
